import { BaseModel } from './basemodel';

export class Supplier extends BaseModel {
  id: number;
  name: string;
}
